import { PrintType } from '@/types';
import { Embroidery, EmbroideryDigital } from '@/model/printType/printTypes';
import { isDigital } from './isDigital';

export const limitPrintTypes = (printTypes: PrintType[]) => {
  let hasDigital = false;
  return printTypes.filter((printType) => {
    // limit print type selection to a single embroidery type (prefer the digital type)
    if (printType.id === Embroidery && printTypes.some(({ id }) => id === EmbroideryDigital)) {
      return false;
    }

    // limit print type selection to a single digital print type
    if (isDigital(printType)) {
      if (hasDigital) {
        return false;
      }
      hasDigital = true;
    }

    return true;
  });
};
